<template>
  <div class="linkGroup_box">
    <div class="flexout">
      <i class="el-icon-phone text"></i
      ><span class="text" @click="loginCommnicate" style="cursor: pointer">{{
        loginStatusText
      }}</span>
    </div>
    <div class="flexout">
      <span class="line"></span><span class="text">语音对讲</span>
    </div>
    <div class="inpH">
      <el-input
        placeholder="请输入人员名称进行搜索"
        v-model="filterText"
      ></el-input>
    </div>
    <ul class="gropPeople">
      <li class="goupOne" v-for="(item, index) in groupList" :key="index">
        <div class="leftTab" :class="{ activetab: activeGroup == index }">
          <el-checkbox
            :indeterminate="item.indeterminate"
            v-model="item.checkAll"
            @change="handleCheckAllChange(index)"
            style="padding-right: 6px"
          ></el-checkbox>

          <span @click="changeTab(index)" class="group">{{ item.name }}</span>
        </div>
        <div
          class="closetemp"
          @click="closeTempm(index)"
          v-if="item.isTemporary && item.isShow"
        ></div>
      </li>
      <!-- @change="handleOneChange(ind)"v-model="item.checkedAllArr" -->
      <template v-for="(item, ind) in groupList">
        <div class="rightTab" v-if="activeGroup == ind" :key="ind">
          <!-- <el-checkbox-group  v-model="item.checkedAllArr"> -->
          <el-checkbox
            v-for="(childItem, childind) in item.children"
            :key="childItem.id"
            @change="handleOneChange(childind)"
            v-model="childItem.isChecked"
            :disabled="childItem.id == LoginSend.strNumber"
            ><img
              src="../../../theme-default/src/img/default_person.png"
              alt=""
              @dblclick="MakeCall(childItem.id)"
            />
            <el-tooltip placement="bottom">
              <div slot="content">
                {{ childItem.name }}
              </div>
              <div>{{ childItem.name }}</div>
            </el-tooltip> </el-checkbox
          ><!-- </el-checkbox-group> -->
        </div>
      </template>
    </ul>
    <div id="voice" class="voiceBox" @click="newTalk"></div>
    <div id="video" class="videoBox" @click="newVideoTalk"></div>
    <div>
      <el-dialog
        title="通话"
        width="360px"
        :visible.sync="dialogFormVisible"
        :show-close="false"
        :append-to-body="true"
        :close-on-click-modal="false"
      >
        <span style="padding-top: 10px; padding-left: 10px">{{ CallMsg }}</span>
        <div slot="footer" class="dialog-footer">
          <!-- <canvas
            id="videoWin"
            width="320px"
            height="240px"
            hidden
            style="margin: -30px 0px 0px -16px"
          ></canvas> -->
          <el-button @click="hangupVideo">挂断</el-button>
          <!-- <el-button v-if="isShowAnswerButton == true" @click="isAnswer = true"
            >接听</el-button
          > -->
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import MyApis from "../../../apis";
import WebSocketApi from "../../../../../../websoket/intercomWebsocket";
import { saveMsg } from "../../../../../../request/msgApi";
const strNumber = global.$config.api.strNumber;
const strPassword = global.$config.api.strPassword;
const strLocalIP = global.$config.api.strLocalIP;
const strServer = global.$config.api.strServer;

export default {
  data() {
    return {
      dialogFormVisible: false,
      activeGroup: 0,
      filterText: "",
      tabPosition: "left",
      ckeckAllNum: [1, 2, 3, 4],
      checkAll: false,
      isIndeterminate: true,
      activeInd: "0",
      GroupDataTimer: "",
      GroupTimerCount: 0,
      GetPttGroupTimer: "",
      GetPttGroupTimerCount: 0,
      GetPttGroupMembersListTimer: "",
      GetPttGroupMembersListTimerCount: 0,
      CallDataTimer: "",
      InitTimer: "",
      calldata: undefined,
      groupList: [],
      showGroup: [],
      isShowAnswerButton: false,
      isUseFilter: false,
      TemporaryCall: [
        {
          checkAll: true,
          id: "",
          name: "山顶SOS",
          children: [{ name: "山顶SOS", id: "allli", isChecked: true }],
          checkedAllArr: [],
          isShow: true,
          isTemporary: true /*是否临时行程的组*/,
          indeterminate: false /* 属性用以表示 checkbox 的不确定状态，一般用于实现全选的效果*/,
        },
      ],
      istogroup: false,
      isAnswer: false,
      deptArray: [] /*用户部门列表*/,
      userStateArray: [] /*用户状态列表*/,
      //声明一个变量来注册监听事件
      getSocketData: null,
      pttGroupArray: [] /*对讲组列表*/,
      pttGroupMembersArray: [] /*对讲组成员列表*/,
      loginStatusText: strNumber + "登录中...",
      LoginSend: {
        strNumber: strNumber,
        strPassword: strPassword,
        strLocalIP: strLocalIP,
        strServer: strServer,
      },
      TimerCount: 0,
      tempGroupList: [],
    };
  },
  props: {
    CallMsg: { type: String, default: "等待回铃" },
    groupArray: { type: Array, default: [] },
  },
  computed: {
    ...mapGetters(["getConnect"]),
    filterInp: function (val) {
      let data = this.groupList;
      data.forEach((item) => {
        return item.children.filter(function (number) {
          console.log(number);
        });
      });
    } /* ...mapState({ 'getConnect':state => state.connectInfo }),*/,
  },
  watch: {
    activeInd: function (val) {
      /*console.log(val)*/
    },
    getConnect: function (val) {
      /*console.log(val)*/
      if (val) {
        this.groupList = this.groupList.push(this.TemporaryCall);
        /*console.log(this.groupList)*/
      }
    },
    // dialogFormVisible: function (val) {
    //   /*console.log("dialogFormVisible",val);*/
    //   if (val == false) {
    //     this.HangUp();
    //   }
    // },
    isAnswer: function (val) {
      /*console.log("isAnswer",val);*/
      if (val) {
        this.isShowAnswerButton = false;
        this.Answer();
        this.isAnswer = false;
      }
    },
    filterText(val) {
      let data = this.tempGroupList;
      let newArr = [];
      if (val) {
        data.forEach((item) => {
          let result = item.children.filter(function (number) {
            /*console.log(number)*/ return number.name.indexOf(val) > -1;
          });
          if (result.length > 0) {
            let obj = {
              checkAll: item.checkAll,
              name: item.name,
              children: result,
              checkedAllArr: item.checkedAllArr,
            };
            newArr.push(obj);
          }
        });
        /*console.log(newArr)*/
        this.groupList = newArr;
        this.isUseFilter = true;
        // this.activeInd = "0";
      } else {
        this.groupList = this.showGroup;
        this.isUseFilter = false;
        // this.activeInd = "0";
      }
    },
    groupArray(val) {
      if (val && val.length > 0) {
        this.groupList = val;
      }
    },
  },
  created() {
    /*this.groupList = this.showGroup;*/
    if (this.groupArray && this.groupArray.length > 0) {
      this.groupList = this.groupArray;
      this.tempGroupList = [...this.groupArray];
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.InitCanvas();
    // });
    /*时间处理*/
    this.InitTimer = setInterval(() => {
      this.InitConnect(false);
    }, 1000);
    this.getSocketMessage();
  },
  methods: {
    getSocketMessage() {
      // 创建接收消息函数
      this.getSocketData = (e) => {
        let msgdat = e && e.detail.data;
        //这边编写处理服务端消息代码
        if (msgdat) {
          /*获取所有用户组*/
          if (msgdat.indexOf("SubscriberGroups") != -1) {
            console.log("获取所有用户组成功");
            var myobj = JSON.parse(msgdat);
            const subscriberGroupsArray = myobj.SubscriberGroups;
            this.deptArray = [];
            for (var i = 0; i < subscriberGroupsArray.length; i++) {
              var strText = "";
              var obj = subscriberGroupsArray[i];
              var dept = {};
              dept.GroupName = obj.GroupName;
              dept.GroupMembers = obj.GroupMembers;
              dept.ParentGroup = "";
              this.deptArray.push(dept);
              this.getChildGroups(obj);
              this.GetGroupData();
            }
          }
          /*获取所有对讲组*/
          if (msgdat.indexOf("GetPttGroupList") != -1) {
            //console.log("获取所有对讲组成功");
            var myobj = JSON.parse(msgdat);
            this.pttGroupArray = myobj.GetPttGroupList;
            this.GetPttGroup();
          }
          /*获取某个对讲组的成员*/
          if (msgdat.indexOf("GetPttGroupMembersList") != -1) {
            //console.log("获取某个对讲组的成员");
            var myobj = JSON.parse(msgdat);
            this.pttGroupMembersArray = myobj.GetPttGroupMembersList;
            this.GetPttGroupMembersList();
          }

          var arrInfo = msgdat.split(":");

          if (arrInfo.length == 2) {
            if (arrInfo[0] == "OnStartVideoPlayer") {
              this.GetMakeCallData();
            } else if (arrInfo[0] == "OnPhoneLineState") {
              this.GetMakeCallData();
            }
          }
        }
      };
      //注册监听事件
      window.addEventListener("onmessageWS", this.getSocketData);
      this.GetGroupData();
    },
    loginCommnicate() {
      var LoginState = WebSocketApi.GetLoginState();
      if (LoginState == "Success") {
        return;
      } else {
        this.loginStatusText = global.$config.api.strNumber + "重新登录...";
        //重新登录
        // this.logOutWebSocket();
        this.InitWebSocket();
        this.InitTimer = setInterval(() => {
          this.InitConnect(true);
        }, 1000);
        //this.getSocketMessage();
      }
    },
    //登录融合通讯
    InitWebSocket() {
      this.ws = WebSocketApi.OpenWebsoket(this.LoginSend);
    },
    //退出融合通讯登录
    logOutWebSocket() {
      WebSocketApi.Logout();
    },

    InitCanvas() {
      var canvas = document.getElementById("videoWin");
      var context =
        canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      context.clearColor(0, 0, 0, 1);
      context.clear(context.COLOR_BUFFER_BIT);
    },
    InitConnect(val) {
      var ConnectState = WebSocketApi.GetConnectState();
      if (this.TimerCount++ > 5) {
        this.TimerCount = 0;
        clearInterval(this.InitTimer);
        this.loginStatusText = global.$config.api.strNumber + "登录失败";
        return;
      }
      if (ConnectState == "Success") {
        var LoginState = WebSocketApi.GetLoginState();
        if (LoginState == "Success") {
          // this.GroupDataTimer = setInterval(this.GetGroupData, 2000);
          //this.GetGroupData();
          // /*获取用户组信息*/
          // this.GetPttGroupTimer = setInterval(this.GetPttGroup, 3000);
          /*获取对讲组信息*/
          // this.CallDataTimer = setInterval(this.GetMakeCallData, 1000);
          /*获取对讲组信息*/
          if (val) {
            this.searchGroup();
          }
          this.TimerCount = 0;
          clearInterval(this.InitTimer);
          this.loginStatusText = global.$config.api.strNumber + "登录成功";
        } else if (LoginState == "Fail") {
          this.TimerCount = 0;
          clearInterval(this.InitTimer);
          this.loginStatusText = global.$config.api.strNumber + "登录失败";
        }
      } else if (ConnectState == "Fail") {
        this.TimerCount = 0;
        clearInterval(this.InitTimer);
        this.loginStatusText = global.$config.api.strNumber + "登录失败";
      }
    },
    //重新登录时发送获取用户组指令
    searchGroup() {
      WebSocketApi.SendAllSubscribers();
      WebSocketApi.SendAllSubscriberGroups();
      WebSocketApi.SendGetPttGroupList();
    },
    GetGroupData() {
      /*获取用户组*/
      let that = this;
      // if (this.GroupTimerCount++ > 50) {
      //   that.$message({ type: "error", message: "获取对用户组信息超时" });
      //   this.GroupTimerCount = 0;
      //   //console.log("获取对用户组信息超时");
      //   clearInterval(this.GroupDataTimer);
      //   return;
      // }
      // let subscribersgroupsArray = WebSocketApi.GetAllSubscriberGroups();
      let subscribersgroupsArray =
        this.deptArray.length > 0
          ? this.deptArray
          : WebSocketApi.GetAllSubscriberGroups();
      if (
        subscribersgroupsArray != undefined &&
        subscribersgroupsArray.length > 0
      ) {
        this.loginStatusText = global.$config.api.strNumber + "登录成功";
        this.showGroup = [];
        subscribersgroupsArray.forEach((item) => {
          let GroupItem = {
            checkAll: false,
            id: item.GroupName,
            name: item.GroupName,
            children: [],
            checkedAllArr: [],
            isShow: true,
            isTemporary: false /*是否临时行程的组*/,
            indeterminate: false /* 属性用以表示 checkbox 的不确定状态，一般用于实现全选的效果*/,
          };
          var members = item.GroupMembers.split(",");
          if (members != undefined && members.length > 0) {
            members.forEach((mitem) => {
              let childitem = {
                name: WebSocketApi.GetUserNameByNum(mitem),
                EnableVideo: WebSocketApi.GetEnableVideoByNum(mitem),
                id: mitem,
                isChecked: false,
              };
              GroupItem.children.push(childitem);
            });
          }
          this.showGroup.push(GroupItem);
        });
        /*console.log("showGroup",this.showGroup);*/
        this.groupList = this.showGroup;
        this.GroupTimerCount = 0;

        // clearInterval(this.GroupDataTimer);
      }
      this.groupList = this.showGroup;
      this.tempGroupList = [...this.showGroup];
    },
    GetPttGroup() {
      /*获取对讲组*/
      let that = this;
      // if (this.GetPttGroupTimerCount++ > 50) {
      //   that.$message({ type: "error", message: "获取对讲机组信息超时" });
      //   //console.log("获取对讲机组信息超时");
      //   this.GetPttGroupTimerCount = 0;
      //   clearInterval(this.GetPttGroupTimer);
      //   return;
      // }
      //let PttGroupArray = WebSocketApi.GetPttGroupList();
      if (this.PttGroupArray != undefined && this.PttGroupArray.length > 0) {
        /*console.log("PttGroupArray",PttGroupArray);*/
        this.PttGroupArray.forEach((item) => {
          let GroupItem = {
            checkAll: false,
            id: item.Number,
            name: item.Name,
            children: [],
            checkedAllArr: [],
            isShow: true,
            isTemporary: false /*是否临时行程的组*/,
            indeterminate: false /* 属性用以表示 checkbox 的不确定状态，一般用于实现全选的效果*/,
          };
          this.showGroup.push(GroupItem);
          //console.log("对讲机通讯", "获取所有对讲组成员" + item.Number);
          WebSocketApi.SendGetPttGroupMembersList(item.Number);
          // this.GetPttGroupMembersListTimer = setInterval(
          //   this.GetPttGroupMembersList,
          //   5000
          // );
          /*获取某个对讲组的成员*/
        });
        // this.GetPttGroupTimerCount = 0;
        // clearInterval(this.GetPttGroupTimer);
      }
    },
    GetPttGroupMembersList() {
      let that = this;
      // if (this.GetPttGroupMembersListTimerCount++ > 50) {
      //   that.$message({ type: "error", message: "获取某个对讲组的成员超时" });
      //   this.GetPttGroupMembersListTimerCount = 0;
      //   clearInterval(this.GetPttGroupMembersListTimer);
      //   return;
      // }
      //let pttGroupMembers = WebSocketApi.GetPttGroupMembersList();
      if (this.pttGroupMembersArray != undefined) {
        this.showGroup.forEach((item) => {
          if (item.id == this.pttGroupMembersArray.PttGroupNumber) {
            var members = this.pttGroupMembersArray.Members.split(",");
            if (members != undefined && members.length > 0) {
              members.forEach((mitem) => {
                let childitem = {
                  name: WebSocketApi.GetUserNameByNum(mitem),
                  id: mitem,
                  isChecked: false,
                };
                item.children.push(childitem);
              });
            }
          }
        });
        /*console.log("pttGroupMembers",pttGroupMembers);*/
        // this.GetPttGroupMembersListTimerCount = 0;
        // clearInterval(this.GetPttGroupMembersListTimer);
      }
    },
    handleCheckAllChange(val) {
      /*console.log('val',val) console.log(index)*/
      let index = val;
      /* let index =Number(this.activeInd);*/
      let status = this.groupList[index].checkAll;
      /*console.log('status') console.log(status) this.groupList[index].checkAll = val;*/
      this.groupList[index].checkAll = status;
      if (status) {
        this.groupList[index].indeterminate = false;
      }
      /* this.groupList[index].checkedAllArr = val ? this.groupList[index].children : [];*/
      let data = this.groupList[index].children;
      data.forEach((item) => {
        item.isChecked = status;
      });
      /*console.log( this.groupList) this.groupList[index].children=data;*/
    },
    handleOneChange(value) {
      /*console.log(value)*/
      /*console.log(value)*/
      let index = Number(this.activeGroup);
      /*console.log('index') console.log(index)*/
      let childata = this.groupList[index].children;
      let checkedCount = 0;
      childata.forEach((item) => {
        if (item.isChecked) {
          checkedCount += 1;
        }
      });
      /*console.log(checkedCount) let checkedCount = value.length;*/
      this.groupList[index].checkAll =
        checkedCount === this.groupList[index].children.length;
      this.groupList[index].indeterminate =
        checkedCount > 0 &&
        checkedCount < this.groupList[index].children.length;
    },
    changeTab(index) {
      this.activeGroup = index;
    },
    closeTempm(index) {
      this.groupList[index].isShow = false;
      this.$emit("closetonghua", false);
      this.removeVoiceClass();
      this.removeVideoClass();
      $("#videoWin").hide();
    },
    addVoiceClass() {
      $("#voice").addClass("flash animated infinite");
    },
    removeVoiceClass() {
      $("#voice").removeClass("flash animated infinite");
    },
    addVideoClass() {
      $("#video").addClass("flash animated infinite");
    },
    removeVideoClass() {
      $("#video").removeClass("flash animated infinite");
    },
    newVoiceTalk() {
      let data = this.groupList;
      let newChildren = [];
      let childNums = "";
      data.forEach((item) => {
        if (item.checkAll) {
          newChildren.push(item.children);
          item.children.forEach((child) => {
            childNums += child.id + ",";
          });
        } else {
          if (item.indeterminate) {
            let childData = item.children;
            childData.forEach((child) => {
              if (child.isChecked) {
                newChildren.push(child);
                childNums += child.id + ",";
              }
            });
          }
        }
      });
      if (newChildren.length == 0) {
        this.$message({ message: "您还没选中人员", type: "error" });
        return;
      }
      if (newChildren.length > 1) {
        this.$message({
          message: "只能选择一位人员进行语音通话",
          type: "error",
        });
        return;
      }
      if (childNums.length > 0) {
        childNums = childNums.substr(0, childNums.length - 1);
        this.MakeCall(childNums);
        this.addVoiceClass();
      }
    },
    newVideoTalk() {
      let data = this.groupList;
      console.log("视频通话", this.groupList);
      let newChildren = [];
      let childNums = "";
      data.forEach((item) => {
        if (item.checkAll) {
          item.children.forEach((child) => {
            childNums += child.id + ",";
            newChildren.push(child);
          });
        } else {
          if (item.indeterminate) {
            let childData = item.children;
            childData.forEach((child) => {
              if (child.isChecked) {
                newChildren.push(child);
                childNums += child.id + ",";
              }
            });
          }
        }
      });
      if (newChildren.length == 0) {
        this.$message({ message: "您还没选中人员", type: "error" });
        return;
      }
      if (newChildren.length > 1) {
        this.$message({
          message: "只能选择一位人员进行视频通话",
          type: "error",
        });
        return;
      }
      if (!newChildren[0].EnableVideo) {
        this.$message({
          message: "该设备无视频功能，请选择语音对讲",
          type: "error",
        });
        return;
      }

      if (childNums.length > 0) {
        childNums = childNums.substr(0, childNums.length - 1);
        this.MakeVideoCall(childNums);
        this.addVideoClass();
        $("#videoWin").show();
      }
    },
    newTalk() {
      let data = this.groupList;
      //console.log("选中的用户", data)
      let newChildren = [];
      let childNums = "";
      data.forEach((item) => {
        if (item.checkAll) {
          item.children.forEach((child) => {
            childNums += child.id + ",";
            newChildren.push(child);
          });
        } else {
          if (item.indeterminate) {
            let childData = item.children;
            childData.forEach((child) => {
              if (child.isChecked) {
                newChildren.push(child);
                childNums += child.id + ",";
              }
            });
          }
        }
      });
      /* console.log(newChildren)*/
      if (newChildren.length == 0) {
        this.$message({ message: "您还没选中人员", type: "error" });
        return;
      }
      if (newChildren.length > 10) {
        this.$message({ message: "选择人员请勿超过10名", type: "error" });
        return;
      }
      if (childNums.length > 0) {
        childNums = childNums.substr(0, childNums.length - 1);
        if (newChildren.length == 1) {
          this.MakeCall(childNums);
        } else {
          this.Conference(childNums);
        }

        this.addVoiceClass();
      }
    },
    MakeCall(id) {
      this.CallMsg = "等待" + id + "接听";
      // this.dialogFormVisible = true;
      console.log("呼叫", id);
      WebSocketApi.MakeCall(id);
    },
    MakeVideoCall(id) {
      this.CallMsg = "等待" + id + "接听";
      // this.dialogFormVisible = true;
      console.log("视频呼叫", id);
      WebSocketApi.MakeVideoCall(id);
    },
    GetMakeCallData() {
      this.calldata = WebSocketApi.GetCallData();

      if (this.calldata != undefined && this.calldata.strText != "") {
        this.CallMsg = this.calldata.strText;
      }
      if (this.calldata.CurrentLineState == "振铃") {
        this.isShowAnswerButton = true;
        this.dialogFormVisible = false;
      }
      if (this.calldata.CurrentLineState == "空闲") {
        this.dialogFormVisible = false;
        this.removeVoiceClass();
        this.removeVideoClass();
      }
      if (this.calldata.CurrentLineState == "通话") {
        this.dialogFormVisible = false;
        // if (this.calldata.isVideoCall) {
        //   this.isShowAnswerButton = false;
        //   this.addVideoClass();
        //   $("#videoWin").show();
        // }
      }
    },
    HangUp() {
      console.log("挂断");
      WebSocketApi.HangUp();
      this.dialogFormVisible = false;
      this.removeVoiceClass();
      this.removeVideoClass();
      $("#videoWin").hide();
    },
    hangupVideo() {
      this.HangUp();
    },

    Answer() {
      console.log("接听");
      WebSocketApi.Answer();
      this.addVoiceClass();
    },
    Conference(Nums) {
      this.dialogFormVisible = true;
      console.info(WebSocketApi.getLoginUser());
      this.CallMsg = "临时会议: " + WebSocketApi.getLoginUser() + " => " + Nums;
      console.log("临时会议", Nums);
      WebSocketApi.Conference(Nums);
      //添加临时会议记录
      this.saveCallMsg(Nums);
    },
    saveCallMsg(Nums) {
      this.saveMsg(
        "call",
        "20",
        WebSocketApi.getLoginUser(),
        Nums,
        "10000006",
        "用户呼叫",
        "1"
      );
    },
    saveMsg(
      messageType,
      status,
      callNumber,
      oppNumber,
      kind,
      categoryName,
      isRead
    ) {
      let params = {
        creater: ZJApp.ZJUser.current.UserName,
        modifier: ZJApp.ZJUser.current.UserName,
        messageType: messageType,
        dataTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        address: "天山天池",
        longitude: 88.13808,
        latitude: 43.89902,
        content:
          (WebSocketApi.GetUserNameByNum(callNumber) || callNumber) +
          "呼叫" +
          (WebSocketApi.GetUserNameByNum(oppNumber) || oppNumber),
        status: status,
        category: kind,
        kind: kind,
        categoryName: categoryName,
        // level: level,
        // type: "emergency_event", // 类型(0人工处理，1、转任务， 2、转应急)
        videos: "",
        audios: "",
        images: "",
        sourceId: null, //关联任务id，非必传
        sourceName:
          "【调度系统】" +
          (WebSocketApi.GetUserNameByNum(callNumber) || callNumber),
        isRead: isRead,
      };
      saveMsg(params);
    },
    /*/获取用户组下的子组*/
    getChildGroups(parentGrp) {
      var childs = parentGrp.GroupChilds;
      if (typeof childs != "undefined") {
        for (var i = 0; i < childs.length; i++) {
          var obj = childs[i];
          var dept = {};
          dept.GroupName = obj.GroupName;
          dept.GroupMembers = obj.GroupMembers;
          dept.ParentGroup = parentGrp.GroupName;
          this.deptArray.push(dept);

          this.getChildGroups(obj);
        }
      }
    },
  },
  destroyed() {
    //移除监听器
    window.removeEventListener("onmessageWS", this.getSocketData);
  },
};
</script>
<style lang="scss" scoped>
.flexout {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  height: 22px;
  .line {
    display: inline-block;
    width: 4px;
    height: 22px;
    background: #00c6ff;
    margin-right: 10px;
  }
  .text {
    font-size: 18px;
    line-height: 26px;
    color: #23c3ff;
  }
}

.linkGroup_box {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.inpH {
  height: 30px;
  margin-bottom: 15px;
}

.gropPeople {
  flex: 1;
  overflow: auto;
  position: relative;
  .goupOne {
    width: 100%;
    height: 3rem;
    list-style: none;
    color: 1.6rem;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .leftTab {
      width: 14rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: left;
    }
  }
}

.gropPeople::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  display: none;
}

.rightTab {
  width: 60%;
  height: 85%;
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 0.3rem;
  box-sizing: border-box;
}

.activetab {
  color: #23c3ff;
  font-weight: bold;
}

.closetemp {
  width: 1.9rem;
  height: 1.9rem;
  background: url("../../../theme-default/src/img/wrong.png") no-repeat;
}

.voiceBox {
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background: url("../../../theme-default/src/img/voice.png") no-repeat;
  background-size: cover;
  margin: 0px auto 20px;
  position: absolute;
  left: 30%;
  bottom: 20px;
  margin-left: -3.5rem;
  z-index: 999999;
  cursor: pointer;
}

.videoBox {
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background: url("../../../theme-default/src/img/video.png") no-repeat;
  background-size: cover;
  margin: 0px auto 20px;
  position: absolute;
  left: 70%;
  bottom: 20px;
  margin-left: -3.5rem;
  z-index: 999999;
  cursor: pointer;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

.flash {
  -webkit-animation-name: flash;
  animation-name: flash;
}
.group {
  cursor: pointer;
}
// .group::before {
//   width: 12px;
//   height: 12px;
//   background: #11467d;
//   content: " ";
//   display: inline-block;
//   box-sizing: border-box;
//   border: 1px solid #3d9fff;
//   margin-bottom: -1px;
//   margin-right: 5px;
//   border-radius: 50%;
// }

@-webkit-keyframes flash {
  0%,
  100%,
  50% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0.6;
  }
}

@keyframes flash {
  0%,
  100%,
  50% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0.6;
  }
}
</style>